import { useCallback, useEffect, useState } from "react";

export const LANG_STORAGE_KEY = "language";

export function readAppLanguage() {
  if (typeof window === "undefined") return "fr";
  const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
  return saved === "en" || saved === "fr" ? saved : "fr";
}

/** Langue app (localStorage) — même clé que Landing / MarketFlow. */
export default function useAppLanguage() {
  const [language, setLanguage] = useState(readAppLanguage);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === LANG_STORAGE_KEY) setLanguage(readAppLanguage());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggleLanguage = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const next = language === "fr" ? "en" : "fr";
    window.localStorage.setItem(LANG_STORAGE_KEY, next);
    window.location.reload();
  }, [language]);

  return { language, toggleLanguage, isEn: language === "en" };
}
